import Parse from 'parse'
import { getEndpoint } from '../stores'

Parse.initialize('15eaa65a6d14458698fffb72bec53dd1')
Parse.serverURL = getEndpoint()

const AlterationEvent = Parse.Object.extend('AlterationEvent')
const Account = Parse.Object.extend('Account')

export { Account, AlterationEvent }
